/* ==========================================================================
   TotalPantofi — THEME REDESIGN JS
   DOM-level enhancements: USP strip, trust badges on PDP, discount %,
   product labels, stock urgency, smart image transitions.
   Preserves all theme logic; only adds decorative elements and classes.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Helpers ---------- */
  function svg(paths, viewBox) {
    return '<svg viewBox="' + (viewBox || '0 0 24 24') + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }
  var ICONS = {
    truck:   svg('<path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>'),
    shield:  svg('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/>'),
    clock:   svg('<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>'),
    card:    svg('<rect x="2" y="5" width="20" height="14" rx="3"/><line x1="2" y1="10" x2="22" y2="10"/>'),
    refresh: svg('<polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>'),
    star:    svg('<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>'),
    fire:    svg('<path d="M8.5 14.5A2.5 2.5 0 0 0 11 17a2.5 2.5 0 0 0 2.5-2.5c0-1.38-.5-2-1-3C11.5 8 13 2 13 2S6 8 6 13a6 6 0 0 0 12 0c0-1.5-.5-3-2-4"/>')
  };

  /* ------------------------------------------------------------------ */
  /* 1. USP strip — injected INSIDE header section                      */
  /* ------------------------------------------------------------------ */
  function injectUspStrip() {
    if (document.querySelector('.tp-usp')) return;

    // Cautam SECTIUNEA header (div-ul exterior sticky), nu inner wrapper-ul.
    // USP strip-ul trebuie sa fie INAUNTRUL aceluiasi element sticky ca si
    // dropdown-ul de navigare — altfel browserul il picteaza DEASUPRA dropdown-ului
    // indiferent de z-index, deoarece vine mai tarziu in DOM (regula de "painting order").
    var section = document.querySelector('.shopify-section-header, #shopify-section-header') ||
                  document.querySelector('.shopify-section-group-header-group');
    // Fallback: daca nu gasim sectiunea, folosim header-wrapper-ul
    var fallback = document.querySelector('header.header-wrapper, .header-wrapper');
    var target = section || fallback;
    if (!target) return;

    var strip = document.createElement('div');
    strip.className = 'tp-usp';
    strip.setAttribute('role', 'complementary');
    strip.setAttribute('aria-label', 'Avantaje');
    strip.innerHTML =
      '<div class="tp-usp__item">' + ICONS.truck + '<span>Livrare GRATUITĂ la orice comandă (Curier Clasic sau Easybox)</span></div>' +
      '<div class="tp-usp__item">' + ICONS.refresh + '<span>Retur în 14 zile</span></div>' +
      '<div class="tp-usp__item">' + ICONS.card + '<span>Plată la livrare / Card online</span></div>' +
      '<div class="tp-usp__item">' + ICONS.shield + '<span>Produse 100% originale</span></div>' +
      '<div class="tp-usp__item">' + ICONS.clock + '<span>Livrare rapidă - toate produsele în stoc propriu</span></div>';

    // APPEND INSIDE sectiunea header — USP strip si dropdown sunt acum in ACELASI
    // stacking context; dropdown-ul (z-index:9999) va aparea corect deasupra barei.
    target.appendChild(strip);
  }

  /* ------------------------------------------------------------------ */
  /* 2. Trust block on product page (under add-to-cart)                  */
  /* ------------------------------------------------------------------ */
  function injectTrustOnPDP() {
    if (document.querySelector('.tp-trust')) return;
    var submitBtn = document.querySelector('.product-form__buttons');
    if (!submitBtn) return;
    var trust = document.createElement('div');
    trust.className = 'tp-trust';
    trust.innerHTML =
      '<div class="tp-trust__item">' + ICONS.truck + '<span>Livrare rapidă 24–48h</span></div>' +
      '<div class="tp-trust__item">' + ICONS.refresh + '<span>Retur rapid 14 zile</span></div>' +
      '<div class="tp-trust__item">' + ICONS.shield + '<span>Plată securizată</span></div>';
    submitBtn.parentNode.insertBefore(trust, submitBtn.nextSibling);
  }

  /* ------------------------------------------------------------------ */
  /* 3. Discount % badge on product cards (when sale price exists)       */
  /* ------------------------------------------------------------------ */
  function addDiscountBadges() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.querySelector('.tp-discount-pct')) return;
      var onSale = card.querySelector('.price--on-sale');
      if (!onSale) return;
      var saleItem = onSale.querySelector('.price-item--sale');
      var regItem = onSale.querySelector('.price-item--regular');
      if (!saleItem || !regItem) return;
      var num = function (el) {
        var txt = (el.textContent || '').replace(/[^\d,\.]/g, '').replace('.', '').replace(',', '.');
        return parseFloat(txt);
      };
      var sale = num(saleItem), reg = num(regItem);
      if (!sale || !reg || reg <= sale) return;
      var pct = Math.round((1 - sale / reg) * 100);
      if (pct < 5) return;

      var pill = document.createElement('span');
      pill.className = 'tp-discount-pct';
      pill.textContent = '-' + pct + '%';
      pill.style.cssText = [
        'position:absolute', 'top:1rem', 'left:1rem',
        'background:#dc2626', 'color:#fff', 'padding:.5rem .9rem',
        'border-radius:999px', 'font-weight:800', 'font-size:1.15rem',
        'letter-spacing:.05em', 'box-shadow:0 6px 16px rgba(220,38,38,.4)',
        'z-index:3', 'pointer-events:none'
      ].join(';');
      var media = card.querySelector('.card__media, .card .media');
      if (media) {
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(pill);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 4. "Nou" badge on products added in the last 30 days                */
  /* (detected via [data-product-created] if present)                    */
  /* ------------------------------------------------------------------ */
  function addNewBadges() {
    // Cards that already have a sale badge get no "new" badge to avoid clash.
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.querySelector('.tp-discount-pct')) return;
      if (card.querySelector('.badge')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      // Heuristic: if the collection is 'noutati' or path contains 'noutati'
      if (location.pathname.indexOf('/collections/nouta') === -1 &&
          location.pathname !== '/' ) return;
      if (card.dataset.tpNewDone) return;
      // Only mark the first 3-4 visible cards on homepage
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Fluid image aspect for category banner blocks (homepage tiles)   */
  /* ------------------------------------------------------------------ */
  function polishCategoryTiles() {
    // AI-generated blocks from homepage: ai_gen_block_e1871a4
    var tiles = document.querySelectorAll('[class*="ai_gen_block_e1871a4"], [id*="ai_gen_block_e1871a4"]');
    tiles.forEach(function (t) {
      t.style.borderRadius = getComputedStyle(t).borderRadius || '16px';
      t.style.overflow = 'hidden';
      t.style.transition = 'transform .4s cubic-bezier(.22,1,.36,1), box-shadow .4s';
      t.addEventListener('mouseenter', function () {
        if (reduceMotion) return;
        t.style.transform = 'translateY(-4px)';
        t.style.boxShadow = '0 16px 40px rgba(0,0,0,.14)';
      });
      t.addEventListener('mouseleave', function () {
        t.style.transform = '';
        t.style.boxShadow = '';
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Collection grid: add stagger class to featured-collection grids  */
  /* ------------------------------------------------------------------ */
  function hydrateStagger() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll(
      '.product-grid, .grid.product-grid, .collection-list__grid'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('te-stagger', 'is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    targets.forEach(function (t) {
      if (t.children && t.children.length > 0) {
        t.classList.add('te-stagger');
        io.observe(t);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 7. Fix double-scroll on mobile for sticky header groups             */
  /* ------------------------------------------------------------------ */
  function fixScrollPadding() {
    var header = document.querySelector('.shopify-section-header-sticky, .header-wrapper');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.scrollPaddingTop = (h + 20) + 'px';
  }

  /* ------------------------------------------------------------------ */
  /* 8. Observe DOM mutations to re-run enhancements for injected blocks */
  /* Debounce 200ms — previne reapeluri excesive la mutații frecvente   */
  /* ------------------------------------------------------------------ */
  function observe() {
    if (!('MutationObserver' in window)) return;
    var debounceTimer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        addDiscountBadges();
        hydrateStagger();
      }, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ */
  /* 9. Rebind on theme editor events                                    */
  /* ------------------------------------------------------------------ */
  function bindShopifyEditor() {
    document.addEventListener('shopify:section:load', function () {
      injectUspStrip();
      injectTrustOnPDP();
      addDiscountBadges();
      hydrateStagger();
      polishCategoryTiles();
      fixScrollPadding();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Nav dropdown tracker — hide USP strip while a top-nav dropdown      */
  /* is open. Painting order / z-index heroics failed repeatedly, so we  */
  /* go direct: body.tp-nav-open -> .tp-usp becomes visibility:hidden.   */
  /* ------------------------------------------------------------------ */
  function bindNavOpenTracker() {
    function sync() {
      var openDetail = document.querySelector(
        '.header__inline-menu details[open], header-menu details[open], .header details[open]'
      );
      document.body.classList.toggle('tp-nav-open', !!openDetail);
    }
    // Delegated listener: toggle events bubble on <details>
    document.addEventListener('toggle', function (e) {
      if (!e.target || e.target.tagName !== 'DETAILS') return;
      // Only react to nav details, not mobile facets / drawers / accordions
      if (!e.target.closest('.header__inline-menu, header-menu, .header')) return;
      sync();
    }, true);
    // Close on outside click / escape (Dawn usually handles this, sync anyway)
    document.addEventListener('click', function () { setTimeout(sync, 10); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setTimeout(sync, 10);
    });
    sync();
  }

  function init() {
    injectUspStrip();
    injectTrustOnPDP();
    addDiscountBadges();
    addNewBadges();
    polishCategoryTiles();
    hydrateStagger();
    fixScrollPadding();
    observe();
    bindShopifyEditor();
    bindNavOpenTracker();
    window.addEventListener('resize', fixScrollPadding, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   MOBILE FILTERS FIX — scroll lock + state class
   Watches Dawn's mobile facets <details> and toggles body.tp-filters-open.
   ========================================================================== */
(function () {
  'use strict';

  var scrollY = 0;
  var isLocked = false;  // urmarim daca lock() a fost efectiv apelat

  function lock() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.setProperty('--tp-scroll-lock', (-scrollY) + 'px');
    document.body.classList.add('tp-filters-open');
    isLocked = true;
  }
  function unlock() {
    if (!isLocked) return;  // nu restaura scroll daca lock() nu a fost niciodata apelat
    isLocked = false;
    document.body.classList.remove('tp-filters-open');
    document.documentElement.style.removeProperty('--tp-scroll-lock');
    // Restauram pozitia scroll NUMAI daca userul era scrollat
    if (scrollY > 0) window.scrollTo(0, scrollY);
  }

  function isMobileFacets(el) {
    return el && el.classList && (
      el.classList.contains('mobile-facets__disclosure') ||
      el.classList.contains('mobile-facets__wrapper') ||
      (el.querySelector && el.querySelector('.mobile-facets'))
    );
  }

  // Dawn toggles a "menu-opening" class on the <details> when the drawer opens.
  // Observe attribute/class changes on any <details> inside .mobile-facets__wrapper.
  function watchFacets() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var t = m.target;
        if (!t || t.nodeType !== 1) return;
        if (!t.closest) return;
        if (!t.closest('.mobile-facets__wrapper, .mobile-facets, facet-filters-form')) return;

        // Find the controlling <details> (Dawn uses <details> with menu-opening)
        var detailsEl = t.tagName === 'DETAILS' ? t : t.closest('details');
        if (!detailsEl) return;

        var opening = detailsEl.classList.contains('menu-opening') || detailsEl.open;
        // Only apply on mobile viewports
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (!isMobile) { unlock(); return; }
        if (opening) lock(); else unlock();
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open'],
      subtree: true
    });
  }

  // Also handle the close button click and the backdrop click as a safety net
  function safetyListeners() {
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest && e.target.closest('.mobile-facets__close, .mobile-facets__close-button, .mobile-facets__footer button[type="reset"]');
      if (closeBtn) { setTimeout(unlock, 50); return; }

      // Backdrop click: clicked on .mobile-facets but NOT on .mobile-facets__inner
      var backdrop = e.target.closest && e.target.closest('.mobile-facets');
      var inner = e.target.closest && e.target.closest('.mobile-facets__inner');
      if (backdrop && !inner) { setTimeout(unlock, 50); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('tp-filters-open')) {
        unlock();
      }
    });

    // If viewport grows past mobile, unlock to prevent stuck state
    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 989px)').matches) unlock();
    }, { passive: true });
  }

  function init() {
    watchFacets();
    safetyListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
